import config from '../configuration/config.json'
import axios from 'axios';

// OIDC settings (gluu, keycloak or any OpenID Connect provider) are owned by the Web API.
let oidcConfigRequest = null;

export function getOidcConfig() {
    if (oidcConfigRequest == null) {
        oidcConfigRequest = axios.get(config.operatorportal.apibaseurl + 'document/configurations/oidc-config')
            .then(response => {
                const apiResponse = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
                return apiResponse.message;
            })
            .catch(err => {
                oidcConfigRequest = null;
                throw err;
            });
    }
    return oidcConfigRequest;
}

function base64UrlEncode(bytes) {
    let binary = '';
    bytes.forEach(b => binary += String.fromCharCode(b));
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

async function createPkcePair() {
    const verifier = base64UrlEncode(window.crypto.getRandomValues(new Uint8Array(32)));
    const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return { verifier, challenge: base64UrlEncode(new Uint8Array(digest)) };
}

export async function redirectToLogin() {
    const oidc = await getOidcConfig();
    const params = new URLSearchParams({
        client_id: oidc.clientid,
        response_type: 'code',
        scope: oidc.scope,
        redirect_uri: oidc.redirecturi
    });
    if (oidc.acrvalues) {
        params.append('acr_values', oidc.acrvalues);
    }
    if (oidc.usepkce) {
        const pkce = await createPkcePair();
        // survives the redirect; read back when exchanging the code for tokens
        sessionStorage.setItem('pkce_code_verifier', pkce.verifier);
        params.append('code_challenge', pkce.challenge);
        params.append('code_challenge_method', 'S256');
    }
    window.location = oidc.authorizationendpoint + '?' + params.toString();
}

export function tokenRequestPayload(code) {
    const codeVerifier = sessionStorage.getItem('pkce_code_verifier');
    return codeVerifier ? { code: code, code_verifier: codeVerifier } : { code: code };
}

export async function logoutUrl() {
    const oidc = await getOidcConfig();
    const params = new URLSearchParams({
        client_id: oidc.clientid,
        post_logout_redirect_uri: oidc.postlogoutredirecturi
    });
    const idToken = sessionStorage.getItem('id_token');
    if (idToken) {
        params.append('id_token_hint', idToken);
    }
    return oidc.endsessionendpoint + '?' + params.toString();
}
